import {
  GET_ACCOUNT_PAYMENT,
  GET_COMPANY_LIST,
  GET_PAYMENT_CATEGORY_LIST,
  GET_ACCOUNT_PAYMENT_DETAIL,
  GET_COMPANY_BANK_ACCOUNT_LIST,
  GET_PAYMENT_MODE_CATEGORY_LIST,
  GET_PAYMENT_MODE_LIST,
  GET_PAYMENT_MODE_FOR_PAYMENT_RECEIPT,
  GET_ACCOUNT_PAYMENT_PAID_LIST,
  GET_ACCOUNT_PAYMENT_PAID_DETAIL,
  GET_PROFITABLE_REPORT_GROUP,
  GET_GROUP_EXPORT,
  GET_PROFITABLE_REPORT_CATEGORY,
  GET_PROFITABLE_REPORT_CATEGORY_EXPORT,
  GET_PROFITABLE_REPORT_ITEM,
  GET_PROJECT_LOAN,
  GET_PROJECT_LOAN_EXPORT,
  GET_PROJECT_LOAN_STATUS,
  GET_PROJECT_LOAN_DETAIL,
  GET_PROJECT_LOAN_PROCESS,
  GET_PROJECT_LOAN_PROCESS_EXPORT,
  GET_LOAN_PROCESS_FOR_PROCESS_PLAN_ADD,
  GET_LOAN_PANEL_FOR_PROCESS_PLAN_ADD,
  GET_PROJECT_MORTGAGE,
  GET_PROJECT_MORTGAGE_EXPORT,
  GET_PROJECT_MORTGAGE_DETAILS,
  GET_LOAN_PROCESS_STATUS,
  GET_LOAN_PROCESS_STATUS_EXPORT,
  GET_LOAN_PROCESS_PLAN_DETAIL,
  GET_PROJECT_MORTGAGE_ELIGIBLE_FILE,
  GET_LOAN_PROCESS_STATUS_FOR_UPDATE,
  GET_PROJECT_LOAN_FILTER_PROJECT,
  GET_PROJECT_LOAN_FILTER_BANK,
  GET_LOAN_PROCESS_PLAN_FILTER_PROJECT,
  GET_LOAN_PROCESS_PLAN_FILTER_BANK,
  GET_LOAN_PROCESS_PLAN_FILTER_PANEL,
  GET_LOAN_PROCESS_PLAN_FILTER_PROCESS,
  GET_LOAN_PROCESS_PLAN_FOR_QUERY_CREATE,
  GET_LOAN_PROCESS_PLAN_QUERY,
  GET_LOAN_PROCESS_PLAN_QUERY_EXPORT,
  GET_LOAN_PROCESS_PLAN_QUERY_DETAIL,
  GET_LOAN_PROCESS_PLAN_QUERY_FILTER_PROJECT,
  GET_LOAN_PROCESS_PLAN_QUERY_FILTER_BANK,
  GET_LOAN_PROCESS_PLAN_QUERY_FILTER_PANEL,
  GET_LOAN_PROCESS_PLAN_QUERY_FILTER_RESPONSIBLE,
  GET_LOAN_PROCESS_PLAN_QUERY_FILTER_ACCOUNTABLE,
  GET_LOAN_PROCESS_PLAN_QUERY_FILTER_PROCESS,
  GET_LOAN_PROCESS_PLAN_FILTER_RESPONSIBLE,
  GET_LOAN_PROCESS_PLAN_FILTER_ACCOUNTABLE,
  GET_LOAN_PROCESS_PLAN_QUERY_TEMPLATE,
  GET_LOAN_PROCESS_PLAN_QUERY_REPORT,

  // Vendor Nithish
  GET_VENDOR,
  GET_CONSTITUTION_OF_FIRM,
  GET_VENDOR_DOCUMENTS,
  GET_VENDOR_DOCUMENT_TYPE,
  GET_VENDOR_SERVICE,
  GET_VENDOR_SERVICE_MASTER,
  GET_VENDOR_CONTACT,
  GET_VENDOR_ACCOUNT,
  GET_VENDOR_ACCOUNT_DOCUMENT_TYPE,
  GET_VENDOR_ADDRESS,
  GET_STATE,
  GET_VENDOR_ACTION_HISTORY,
  GET_ACCOUNT_PAYMENT_FILTER_COMPANY,
  GET_ACCOUNT_PAYMENT_FILTER_PROJECT,
  GET_ACCOUNT_PAYMENT_FILTER_REQUESTED_BY,
  GET_ACCOUNT_PAYMENT_FILTER_CATEGORY,
  GET_CHANNEL_PATNER_FILTER_RELATIONSHIP,
  GET_VENDOR_DETAILS,
  GET_VENDOR_CHANGE_REQUEST,
  GET_VENDOR_CHANGE_REQUEST_DETAILS,
  GET_CIVIL_PROJECT_BILL_ACCOUNT,
  GET_CIVIL_PROJECT_BILL_ACCOUNT_EXPORT,
  GET_VENDOR_EXPORT,
  GET_CHANNEL_PARTNER,
  GET_CHANNEL_PARTNER_EXPORT,
  GET_GOVT_FEES,
  GET_GOVT_FEES_PROCESS_PLAN,
  GET_GOVERNMENT_DETAIL,
  GET_GOVT_FEES_PROCESS_ITEM,
  GET_GOVT_FEES_ITEM,
  GET_GOVT_FEES_MODE_CATEGORY,
  GET_GOVT_FEES_FILTER_COMPANY,
  GET_GOVT_FEES_PROCESS_FILTER,
  GET_GOVT_FEES_PROJECT_FILTER,
  GET_GOVT_FEE_SURVEY_NUMBER,
  GET_RETENTION_PERCENTAGE,
  GET_RETENTION_PERCENTAGE_FILTER_BILL_CATEGORY,
  GET_RETENTION_PERCENTAGE_EXPORT,
  GET_BILL_CATEGORY,
  GET_GOVT_FEES_TASK_PLAN,
  GET_VENDOR_LEDGER,
  GET_VENDOR_LEDGER_DETAILS,
  GET_PAYMENT_REQUEST,
  GET_VENDOR_LEDGER_EXPORT,
  GET_PAYMENT_REQUEST_DETAIL,
  VENDOR_LEDGER_ITEM,
  GET_VENDOR_LEDGER_ITEM_EXPORT,
  GET_VENDOR_LEDGER_ITEM_PRINT,
  GET_VENDOR_LEDGER_FILTER_VENDOR,
  GET_VENDOR_LEDGER_FILTER_COMPANY,
  GET_VENDOR_LEDGER_ITEM_FILTER_VENDOR,
  GET_VENDOR_LEDGER_ITEM_FILTER_COMPANY,
  GET_VENDOR_LEDGER_ITEM_FILTER_PROJECT,
  GET_VENDOR_LEDGER_ITEM_FILTER_CATEGORY,
  GET_VENDOR_ACCOUNT_FOR_PAYMENT_REQUEST,
  GET_PAYMENT_REQUEST_EXPORT,
  GET_PAYMENT_REQUEST_FILTER_PROJECT,
  GET_PAYMENT_REQUEST_FILTER_VENDOR,
  GET_PAYMENT_REQUEST_FILTER_CATEGORY,
  GET_PAYMENT_REQUEST_FILTER_REQUESTED_BY,
  GET_PAYMENT_REQUEST_FILTER_COMPANY,
  GET_PAYMENT_REQUEST_APPROVAL,
  GET_PAYMENT_REQUEST_APPROVAL_EXPORT,
  GET_CATEGORY_FOR_PAYMENT_REQUEST,
  GET_VENDOR_PAYMENT_INFO_FOR_PAYMENT_REQUEST,
  GET_VENDOR_PO_WO_FOR_PAYMENT_REQUEST,
  GET_COMPANY_FOR_PAYMENT_REQUEST,
  GET_PROJECT_FOR_PAYMENT_REQUEST,
  GET_VENDOR_FOR_PAYMENT_REQUEST,
  GET_ACCOUNT_CHEQUE_NUMBER,
  GET_PAYMENT_REQUEST_PAID_EXPORT,
  GET_PAYMENT_REQUEST_PAID,
  GET_PAYMENT_REQUEST_PAID_DETAIL,
  GET_PAYMENT_REQUEST_PAID_FILTER_COMPANY,
  GET_PAYMENT_REQUEST_APPROVAL_FILTER_PROJECT,
  GET_PAYMENT_REQUEST_APPROVAL_FILTER_VENDOR,
  GET_PAYMENT_REQUEST_APPROVAL_FILTER_COMPANY,
  GET_PAYMENT_REQUEST_APPROVAL_FILTER_CATEGORY,
  GET_TDS_DEDUCTION,
  GET_TDS_DEDUCTION_EXPORT,
  GET_TDS_DEDUCTION_FILTER_VENDOR,
  GET_TDS_DEDUCTION_FILTER_CATEGORY,
  GET_COST_CENTER,
  GET_COST_CENTER_EXPORT,
  GET_COST_CENTER_CATEGORY_EXPORT,
  GET_PAYMENT_CATEGORY_MASTER_EXPORT,
  GET_ITEM_FOR_EXPENSES,
  GET_EXPENSES_INVOICE,
  GET_EXPENSES_INVOICE_EXPORT,
  GET_EXPENSES_INVOICE_DETAIL,
  GET_EXPENSES_INVOICE_FILTER_PROJECT,
  GET_EXPENSES_INVOICE_FILTER_VENDOR,
  GET_EXPENSES_INVOICE_FILTER_COMPANY,
  GET_EXPENSES_INVOICE_FILTER_COST_CENTER,
  GET_COMPANY_ACCOUNT_MAP,
  GET_COMPANY_ACCOUNT_MAP_FILTER_COMPANY,
  GET_COMPNAY_ACCOUNT_MAP_FILTER_BANK,
  GET_COMPANY_ACCOUNT_MAP_EXPORT,
  GET_SERVICE_FOR_VENDOR,
  GET_PROJECT_LONE_SUMMARY,
  GET_PROJECT_LONE_SUMMARY_EXPORT,
  GET_SURVEY_NUMBER_FOR_LOAN_QUERY,

  //petty cash
  GET_PETTY_CASH_EXPORT,
  GET_PETTY_CASH,
  GET_PETTY_CASH_DETAIL,
  GET_PETTY_CASH_FILTER_PROJECT,
  GET_PETTY_CASH_FILTER_DEPARTMENT,
  GET_PETTY_CASH_FILTER_REQUESTED_BY,
  GET_PETTY_CASH_FILTER_COMPANY,
  GET_COST_CENTER_FOR_PETTY_CASH,
  GET_PAYMENT_REQUEST_PAID_ITEM,
  GET_PAYMENT_REQUEST_PAID_ITEM_EXPORT,
  GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_COMPANY,
  GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_VENDOR,
  GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_BANK,
  GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_ACCOUNT,
  GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_CATEGORY,
  GET_EXPENSES_INVOICE_FILTER_CATEGORY,
  GET_PAYMENT_CATEGORY_MASTER,
  GET_SALARY_JV,
  GET_SALARY_EMPLOYER_PF_DETAIL,
  GET_SALARY_JV_EXPORT,
  GET_SALARY_JV_FILTER_COMPANY,
  GET_COST_CENTER_CATEGORY,
  GET_TDS_FOR_BILL,
  GET_SALARY_JV_DETAIL,
  GET_COST_CENTER_MASTER,
  GET_EXPENSES_INVOICE_ACCOUNT_EXPORT,
  GET_EXPENSES_INVOICE_ACCOUNT_FILTER_PROJECT,
  GET_EXPENSES_INVOICE_ACCOUNT_FILTER_VENDOR,
  GET_EXPENSES_INVOICE_ACCOUNT_FILTER_COMPANY,
  GET_EXPENSES_INVOICE_ACCOUNT_FILTER_COSTCENTER,
  GET_EXPENSES_INVOICE_ACCOUNT_FILTER_CATEGORY,
  GET_EXPENSES_INVOICE_ACCOUNT,
  GET_SALARY_EMPLOYER_ESI_DETAIL,
  GET_SALARY_ADVANCE_DETAIL,
  GET_PAYMENT_CATEGORY_FOR_EXPENSE,
  GET_STOCK_COMPANY,
  GET_STOCK_COMPANY_EXPORT,
  GET_STOCK_COMPANY_DETAILS,
  GET_DIRECTOR_TYPE,
  GET_PAYMENT_RECIEVED,
  GET_PAYMENT_RECIEVED_EXPORT,
  GET_SALARY_EXPENSE_OTHER_DEDUCTION,
  GET_SALARY_EXPENSE_OTHER_DEDUCTION_EXPORT,
  GET_CUSTOMER_FOR_PAYMENT_RECIEVED,
  GET_PAYMENT_RECIEVED_FILTER_COMPANY,
  GET_PAYMENT_RECIEVED_FILTER_PROJECT,
  GET_PAYMENT_RECIEVED_FILTER_ACCOUNT,
  GET_PAYMENT_RECIEVED_FILTER_BANK,
  GET_PAYMENT_RECIEVED_DETAIL,
  GET_PAYMENT_RECEIPT_FILTER_SITE_NUMBER,
  GET_PAYMENT_RECEIPT_FILTER_CATEGORY,
  GET_PAYMENT_RECIEVED_FILTER_STATUS,
  GET_VEHICLE_FUEL_EXPORT,
  GET_VEHICLE_FUEL,
  GET_VEHICLE_FUEL_DETAILS,
  GET_VEHICLE_FUEL_FILTER_EMPLOYEE,
  GET_VEHICLE_FUEL_FILTER_PROJECT,
  GET_PAYMENT_RECIEVED_FILTER_CUSTOMER,
  GET_PAYMENT_STATUS,
  GET_VENDOR_LEDGER_FILTER_CATEGORY,
  GET_CHEQUE_BOOK,
  GET_CHEQUE_BOOK_EXPORT,
  GET_CHEQUE_BOOK_FILTER_COMPANY,
  GET_CHEQUE_BOOK_FILTER_ACCOUNT,
  GET_CHEQUE_BOOK_USAGE,
  GET_CHEQUE_BOOK_USAGE_EXPORT,
  GET_CHEQUE_BOOK_USAGE_FILTER_COMPANY,
  GET_CHEQUE_BOOK_USAGE_FILTER_ACCOUNT,
  GET_CHEQUE_BOOK_USAGE_FILTER_STATUS,
  GET_CHEQUE_BOOK_STATUS,
  GET_CHEQUE_BOOK_NUMBER_FOR_CHEQUE,
  GET_COMPANY_FOR_CHEQUE_USAGE,
  GET_CHEQUE_BOOK_DETAILS,
  GET_CHEQUE_BOOK_USAGE_DETAILS,
  GET_CARD_EXPORT,
  GET_CARD,
  IMPORT_CHANNEL_PARTNER,
  GET_DEMAND_DRAFT_REQUEST,
  GET_DEMAND_DRAFT_REQUEST_DETAIL,
  GET_VENDOR_FILTER_SERVICE,
  GET_PETTY_CASH_ACCOUNTS,
  GET_PETTY_CASH_ACCOUNTS_EXPORT,
  GET_PETTY_CASH_ACCOUNTS_FILTER_PROJECT,
  GET_PETTY_CASH_ACCOUNTS_FILTER_COMPANY,
  GET_PETTY_CASH_ACCOUNTS_FILTER_REQUESTED_BY,
  GET_PETTY_CASH_ACCOUNTS_FILTER_DEPARTMENT,
  GET_PETTY_CASH_SETTING,
  // Accounts Director(SVM)
  GET_DIRECTOR,
  GET_DIRECTOR_DETAIL,
  GET_DOCUMENT_TYPE,
  //ACCOUNTS Din Verification(SVM)
  GET_DIN_VERIFICATION,
  GET_DIN_VERIFICATION_DETAIL,
  GET_GOVT_FEES_FILTER_REQUESTED_BY,
  GET_COMPANY_FOR_ASSET_GROUP,
  GET_DEMAND_DRAFT_REQUEST_FILTER_PROJECT,
  GET_DEMAND_DRAFT_REQUEST_FILTER_VENDOR,
  GET_PAYMENT_RECEIVED_STATUS,
  GET_STATUS_FOR_PAYMENT_RECEIPT,
  GET_REASON_FOR_NOT_REALIZED_PAYMENT,
  GET_LEASE,
  GET_LEASE_FILTER_LESSEE,
  GET_LEASE_FILTER_LESSOR,
  GET_LEASE_DETAIL,
  // RERA-Applivcation
  GET_RERA_APPLICATION,
  GET_RERA_APPLICATION_EXPORT,
  GET_RERA_AUTHORITIES,
  GET_RERA_APPLICATION_DETAIL,
  GET_RERA_QUERY,
  GET_RERA_QUERY_EXPORT,
  GET_RERA_APPLICATION_PROJECT,
  GET_RERA_QUERY_PROJECT,
  GET_RERA_QUERY_DETAILS,
  GET_RERA_QUERY_FILTER_PROJECT,
  GET_RERA_APPLICATION_FILTER_PROJECT,
  GET_RERA_QUERY_FILTER_RESPONSIBLE,
  GET_RERA_QUERY_FILTER_ACCOUNTABLE,
  GET_RERA_FILING,
  GET_RERA_FILING_EXPORT,
  GET_RERA_FILING_DETAIL,
  GET_RERA_FILING_FILTER_PROJECT,
  GET_CARD_DETAILS,
  GET_LOAN_CATEGORY,
  GET_LOAN_CATEGORY_EXPORT,
  GET_LOAN_SECURITY,
  GET_LOAN_SECURITY_EXPORT,
  GET_LOAN_SECURITY_FILTER_COMPANY,
  GET_LOAN_SECURITY_FILTER_BANK,
  GET_LOAN,
  GET_LOAN_EXPORT,
  GET_LOAN_DETAILS,
  GET_LOAN_PENALTY_REASON,
  GET_LOAN_FILTER_COMPANY,
  GET_LOAN_FILTER_BANK,
  GET_LOAN_FILTER_CATEGORY,
  GET_LAND_FOR_LOAN_SECURITY,
  GET_SITE_FOR_LOAN_SECURITY,
  GET_LOAN_SECURITY_FILTER_PROJECT,
  GET_LOAN_SECURITY_FILTER_LENDER,
  GET_LOAN_FILTER_LENDER,
  // cheque usage
  GET_CHEQUE_BOOK_USAGE_REPORT,
  GET_CHEQUE_BOOK_USAGE_REPORT_DETAILS,
  GET_CHEQUE_BOOK_USAGE_REPORT_DETAILS_EXPORT,
  //TDS Section(SVM)
  GET_TDS_SECTION,
  GET_TDS_SECTION_EXPORT,
  GET_TDS_SECTION_DETAIL,
  GET_TDS_DEDUCTION_DETAIL,
  GET_VENDOR_FOR_TDS_DEDUCTION,
  GET_RENT_DETAIL_FOR_RENT_BILL,
  GET_CURRENT_YEAR_MONTH,
  // consultant fees
  GET_PROJECT_CONSULTANT_FEE_DETAIL,
  GET_PROJECT_CONSULTANT_FEE_EXPORT,
  GET_PROJECT_CONSULTANT_FEE,
  GET_PROJECT_CONSULTANT,
  GET_SURVEY_FOR_PROJECT_CONSULTANT_FEE,
  GET_PROJECT_CONSULTANT_FEE_FILTER_PROJECT,
  GET_PROJECT_CONSULTANT_FEE_FILTER_CONSULTANT,
  //  Cheque Template
  GET_CHEQUE_TEMPLATE,
  GET_CHEQUE_TEMPLATE_EXPORT,
  GET_CHEQUE_TEMPLATE_DETAIL,
  GET_CHEQUE_TEMPLATE_FILTER_BANK,
  //customer ledger
  GET_CUSTOMER_LEDGER,
  GET_CUSTOMER_LEDGER_ITEM_PRINT,
  GET_CUSTOMER_LEDGER_EXPORT,
  GET_CUSTOMER_LEDGER_DETAIL,
  GET_CUSTOMER_LEDGER_FILTER_PROJECT,
  GET_CUSTOMER_LEDGER_FILTER_CUSTOMER,
  GET_CUSTOMER_LEDGER_FILTER_COMPANY,
  GET_CUSTOMER_LEDGER_FILTER_CATEGORY,
  GET_CUSTOMER_LEDGER_ITEM,
  GET_CUSTOMER_LEDGER_ITEM_EXPORT,
  GET_CUSTOMER_LEDGER_ITEM_FILTER_CUSTOMER,
  GET_CUSTOMER_LEDGER_ITEM_FILTER_COMPANY,
  GET_CUSTOMER_LEDGER_ITEM_FILTER_CATEGORY,
  GET_CUSTOMER_LEDGER_ITEM_FILTER_PROJECT,
  // sales return (Credit Note)
  GET_SALES_RETURN_FILTER_COMPANY,
  GET_SALES_RETURN_FILTER_PROJECT,
  GET_SALES_RETURN_EXPORT,
  GET_SALES_RETURN,
  GET_SALES_RETURN_DETAIL,
  //account type
  GET_ACCOUNT_TYPE
} from "./types";

const initialStateChart = {
  labels: [],
  datasets: []
};

const initialState = {
  accountPaymentList: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  companyList: {
    error: false,
    message: "",
    company: [],
    totalCount: 0
  },
  paymentCategoryList: {
    error: false,
    message: "",
    company: [],
    totalCount: 0
  },
  accountPaymentDetail: {
    error: false,
    message: "",
    data: []
  },
  companyAccountList: {
    error: false,
    message: "",
    company: [],
    totalCount: 0
  },
  paymentModeCategoryList: {
    error: false,
    message: "",
    company: [],
    totalCount: 0
  },
  paymentModeList: {
    error: false,
    message: "",
    company: [],
    totalCount: 0
  },
  getPaymentModeForPaymentReceipt: {
    error: false,
    message: "",
    company: [],
    totalCount: 0
  },
  accountPaymentPaidList: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  accountPaymentPaidDetail: {
    error: false,
    message: "",
    data: []
  },
  getProfitableReportGroup: {
    error: false,
    message: "",
    data: []
  },
  getGroupExport: {
    error: false,
    message: "",
    data: []
  },
  getProfitableReportCategory: {
    error: false,
    message: "",
    data: []
  },
  getProfitableReportCategoryExport: {
    error: false,
    message: "",
    data: []
  },
  getProfitableReportItem: {
    error: false,
    message: "",
    data: []
  },
  getProjectLoan: {
    data: [],
    message: "",
    error: false,
    totalCount: 0
  },
  getProjectLoanExport: {
    data: [],
    message: "",
    error: false,
    totalCount: 0
  },
  getProjectLoanStatus: {
    data: [],
    message: "",
    error: false,
    totalCount: 0
  },
  getProjectLoanDetail: [],
  getProjectLoanProcess: {
    error: false,
    message: "",
    data: []
  },
  getProjectLoanProcessExport: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessForProcessPlanAdd: {
    error: false,
    message: "",
    data: []
  },
  getLoanPanelForProcessPlanAdd: {
    error: false,
    message: "",
    data: []
  },
  getProjectMortgage: {
    error: false,
    message: "",
    data: []
  },
  getProjectMortgageExport: {
    error: false,
    message: "",
    data: []
  },
  getProjectMortgageDetails: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessStatus: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessStatusExport: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanDetail: {
    error: false,
    message: "",
    data: []
  },
  getProjectMortgageEligibleFile: {
    error: false,
    message: "",
    data: []
  },

  getLoanProcessStatusForUpdate: {
    error: false,
    message: "",
    data: []
  },
  getProjectLoanFilterProject: {
    error: false,
    message: "",
    data: []
  },
  getProjectLoanFilterBank: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanFilterProject: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanFilterBank: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanFilterProcess: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanFilterPanel: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanForQueryCreate: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanQueryList: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanProcessPlanQueryExport: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanQueryDetail: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanQueryFilterProject: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanQueryFilterBank: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanQueryFilterPanel: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanQueryFilterResponsible: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanQueryFilterAccountable: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanQueryFilterProcess: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanFilterResponsible: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanFilterAccountable: {
    error: false,
    message: "",
    data: []
  },
  getLoanProcessPlanQueryTemplete: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanProcessPlanQueryReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Vendor Nithish
  getVendor: {
    error: false,
    message: "",
    data: []
  },
  getConstitutionOfFirm: {
    error: false,
    message: "",
    data: []
  },
  getVendorDocuments: {
    error: false,
    message: "",
    data: []
  },
  getVendorDocumentType: {
    error: false,
    message: "",
    data: []
  },
  getVendorService: {
    error: false,
    message: "",
    data: []
  },
  getVendorServiceMaster: {
    error: false,
    message: "",
    data: []
  },
  getVendorContact: {
    error: false,
    message: "",
    data: []
  },
  getVendorAccount: {
    error: false,
    message: "",
    data: []
  },
  getVendorAccountDocumentType: {
    error: false,
    message: "",
    data: []
  },
  getVendorAddress: {
    error: false,
    message: "",
    data: []
  },
  getState: {
    error: false,
    message: "",
    data: []
  },
  getVendorActionHistory: {
    error: false,
    message: "",
    data: []
  },
  getAccountPaymentFilterCompany: {
    error: false,
    message: "",
    data: []
  },
  getAccountPaymentFilterProject: {
    error: false,
    message: "",
    data: []
  },
  getAccountPaymentFilterRequestedBy: {
    error: false,
    message: "",
    data: []
  },
  getAccountPaymentFilterCategory: {
    error: false,
    message: "",
    data: []
  },
  getChannelPartnerFilterRelationship: {
    error: false,
    message: "",
    data: []
  },
  getVendorDetails: {
    error: false,
    message: "",
    data: []
  },
  getVendorChangeRequest: {
    error: false,
    message: "",
    data: []
  },
  getVendorChangeRequestDetails: {
    error: false,
    message: "",
    data: []
  },
  getCivilProjectBillAccount: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCivilProjectBillAccountExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChannelPartner: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChannelPartnerExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getGovernmentFees: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getGovernmentFeesProcessPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getGovernmentFeesDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getGovernmentFeesProcessItem: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getGovernmentFeesItem: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getGovernmentFeesModeCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getGovernmentFeesFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getGovernmentFeesFilterProcess: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getGovernmentFeesFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getGovernmentFeesFilterRequestedBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getGovernmentFeesSurveyNumber: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getRetentionPercentage: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getRetentionPercentageFilterBillCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getRetentionPercentageExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getBillCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getGovernmentFeesTaskPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Vendor Ledger
  getVendorLedger: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorLedgerExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorLedgerDetails: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Payment Request Amount
  getPaymentRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestFilterVendor: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestApprovalFilterRequestedBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestFilterComapny: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Vendor Payment Request Account
  getPaymentRequestApproval: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestApprovalExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestApprovalFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestApprovalFilterVendor: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestApprovalFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestApprovalFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Account Payment Paid
  getPaymentRequestPaid: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestPaidExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestPaidDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestPaidFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAccountChequeNumber: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorLedgerItem: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorLedgerItemExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorLedgerItemPrint: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorLedgerFilterVendor: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorLedgerFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorLedgerItemFilterVendor: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorLedgerItemFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorLedgerItemFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorLedgerItemForCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorAccountForPaymentRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCategoryForPaymentRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorPaymentInfoForPaymentRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorPoWoForPaymentRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyForPaymentRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectForPaymentRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorForPaymentRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTdsDeduction: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTdsDeductionExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTdsDeductionFilterVendor: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTdsDeductionFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCostCenterExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCostCenterCategoryExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentCategoryMasterExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCostCenter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getItemForExpenses: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpensesInvoice: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpensesInvoiceExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpensesInvoiceDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpensesInvoiceFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpensesInvoiceFilterVendor: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpensesInvoiceFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpensesInvoiceFilterCostCenter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyAccountMap: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyAccountMapFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyAccountMapFilterBank: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyAccountMapExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getBank: {
    error: false,
    message: "",
    data: []
  },
  getServiceForVendor: {
    error: false,
    message: "",
    data: []
  },

  //loan summary
  getProjectLoanSummary: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectLoanSummaryExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSurveyNumberForLoanQuery: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //petty cash
  getPettyCash: {
    error: false,
    message: "",
    data: []
  },
  getPettyCashExport: {
    error: false,
    message: "",
    data: []
  },
  getPettyCashDetails: {
    error: false,
    message: "",
    data: []
  },
  getPettyCashFilterProject: {
    error: false,
    message: "",
    data: []
  },
  getPettyCashFilterDepartment: {
    error: false,
    message: "",
    data: []
  },
  getPettyCashFilterRequestedBy: {
    error: false,
    message: "",
    data: []
  },
  getPettyCashFilterCompany: {
    error: false,
    message: "",
    data: []
  },
  getCostCenterForPettyCash: {
    error: false,
    message: "",
    data: []
  },
  getPaymentRequestPaidItem: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestPaidItemExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestPaidItemFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestPaidItemFilterVendor: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestPaidItemFilterBank: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestPaidItemFilterAccount: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRequestPaidItemFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpensesInvoiceFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentCategoryMaster: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getSalaryJV: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getSalaryEmployerPfDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalaryEmployerEsiDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalaryAdvanceDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentCategoryForExpense: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalaryJVExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalaryJVFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getCostCenterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getTdsForBill: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getSalaryJvDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCostCenterMaster: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getExpensesInvoiceAccount: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpensesInvoiceAccountExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpenseInvoiceAccountFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpenseInvoiceAccountFilterVendor: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpenseInvoiceAccountFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpenseInvoiceAccountFilterCostCenter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpenseInvoiceAccountFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSpecification: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSpecificationValue: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getModel: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMake: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getStockCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getStockCompanyExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDirectorType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Payment Receit
  getPaymentRecieved: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRecievedExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerForPaymentRecieved: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalaryExpenseOtherDeduction: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalaryExpenseOtherDeductionExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRecievedFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRecievedFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRecievedFilterAccount: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRecievedFilterCustomer: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRecievedFilterBank: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRecievedDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentReceiptFilterSiteNumber: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentReceiptFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentRecievedFilterStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleFuel: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleFuelExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleFuelDetails: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleFuelFilterEmployee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleFuelFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorLedgerFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeBook: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeBookExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeBookFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeBookFilterAccount: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeBookUsage: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeBookUsageExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeBookUsageFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeBookUsageFilterAccount: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeBookUsageFilterStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeBookStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeBookNumberForCheque: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyForChequeUsage: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeBookDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeBookUsageDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCard: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCardExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  importChannelPartner: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getDemandraftRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getDemandraftRequestDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDemandraftRequestFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getDemandraftRequestFilterVendor: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getVendorFilterService: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPettyCashAccounts: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPettyCashAccountsExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPettyCashAccountsFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPettyCashAccountsFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPettyCashAccountsFilterRequestedBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPettyCashAccountsFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPettyCashSetting: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDirector: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDirectorDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDocumentTypeForDirector: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDinVerification: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDinVerificationDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getValueSetForSpecification: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getCompanyForAssetGroup: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentReceivedStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getStatusForPaymentReceipt: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReasonForNotRealizedPayment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLease: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeaseFilterLessee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeaseFilterLessor: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeaseDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraApplication: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraApplicationExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraAuthorities: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraApplicationDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraQuery: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraQueryExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraApplicationProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraQueryProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraQueryDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraQueryFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraApplicationFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraQueryFilterResponsible: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraQueryFilterAccountable: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraFiling: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraFilingExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraFilingDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReraFilingFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCardDetails: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanCategoryExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanSecurity: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanSecurityExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanSecurityFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanSecurityFilterBank: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanPenaltyReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanFilterBank: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLandForLoanSecurity: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteForLoanSecurity: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanSecurityFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanSecurityFilterLender: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLoanFilterLender: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // cheque usage
  getChequeBookUsageReport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeBookUsageReportDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeBookUsageReportDetailExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // TDS Section
  getTdsSection: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTdsSectionExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTdsSectionDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTdsDeductionDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVendorForTdsDeduction: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Rent Bill
  getCurrentYearMonth: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getRentDetailForRentBill: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // consultantfees
  getProjectConsultant: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectConsultantFee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectConsultantFeeExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectConsultantFeeDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSurveyForProjectConsultantFee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectConsultantFeeFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectConsultantFeeFilterConsultant: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //  Cheque Template
  getChequeTemplate: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeTemplateExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeTemplateDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getChequeTemplateFilterBank: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //customer ledger
  getCustomerLedger: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerLedgerItemPrint: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerLedgerExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerLedgerDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerLedgerFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerLedgerFilterCustomer: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerLedgerFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerLedgerFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerLedgerItem: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerLedgerItemExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerLedgerItemFilterCustomer: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerLedgerItemFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerLedgerItemFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerLedgerItemFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // sales return (Credit Note)
  getSalesReturn: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReturnDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getSalesReturnFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReturnFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalesReturnExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //account type
  getAccountType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  }
};

const Accounts_reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ACCOUNT_PAYMENT:
      return Object.assign({}, state, { accountPaymentList: payload });
    case GET_COMPANY_LIST:
      return Object.assign({}, state, { companyList: payload });
    case GET_PAYMENT_CATEGORY_LIST:
      return Object.assign({}, state, { paymentCategoryList: payload });
    case GET_ACCOUNT_PAYMENT_DETAIL:
      return Object.assign({}, state, { accountPaymentDetail: payload });
    case GET_COMPANY_BANK_ACCOUNT_LIST:
      return Object.assign({}, state, { companyAccountList: payload });
    case GET_PAYMENT_MODE_CATEGORY_LIST:
      return Object.assign({}, state, {
        paymentModeCategoryList: payload
      });
    case GET_PAYMENT_MODE_LIST:
      return Object.assign({}, state, { paymentModeList: payload });
    case GET_PAYMENT_MODE_FOR_PAYMENT_RECEIPT:
      return Object.assign({}, state, {
        getPaymentModeForPaymentReceipt: payload
      });
    case GET_ACCOUNT_PAYMENT_PAID_LIST:
      return Object.assign({}, state, {
        accountPaymentPaidList: payload
      });
    case GET_ACCOUNT_PAYMENT_PAID_DETAIL:
      return Object.assign({}, state, {
        accountPaymentPaidDetail: payload
      });
    case GET_PROFITABLE_REPORT_GROUP:
      return Object.assign({}, state, {
        getProfitableReportGroup: payload
      });
    case GET_GROUP_EXPORT:
      return Object.assign({}, state, { getGroupExport: payload });
    case GET_PROFITABLE_REPORT_CATEGORY:
      return Object.assign({}, state, {
        getProfitableReportCategory: payload
      });
    case GET_PROFITABLE_REPORT_CATEGORY_EXPORT:
      return Object.assign({}, state, {
        getProfitableReportCategoryExport: payload
      });
    case GET_PROFITABLE_REPORT_ITEM:
      return Object.assign({}, state, {
        getProfitableReportItem: payload
      });
    case GET_PROJECT_LOAN:
      return Object.assign({}, state, { getProjectLoan: payload });
    case GET_PROJECT_LOAN_EXPORT:
      return Object.assign({}, state, { getProjectLoanExport: payload });
    case GET_PROJECT_LOAN_STATUS:
      return Object.assign({}, state, { getProjectLoanStatus: payload });
    case GET_PROJECT_LOAN_DETAIL:
      return Object.assign({}, state, { getProjectLoanDetail: payload });
    case GET_PROJECT_LOAN_PROCESS:
      return Object.assign({}, state, { getProjectLoanProcess: payload });
    case GET_PROJECT_LOAN_PROCESS_EXPORT:
      return Object.assign({}, state, {
        getProjectLoanProcessExport: payload
      });
    case GET_LOAN_PROCESS_FOR_PROCESS_PLAN_ADD:
      return Object.assign({}, state, {
        getLoanProcessForProcessPlanAdd: payload
      });
    case GET_LOAN_PANEL_FOR_PROCESS_PLAN_ADD:
      return Object.assign({}, state, {
        getLoanPanelForProcessPlanAdd: payload
      });
    case GET_PROJECT_MORTGAGE:
      return Object.assign({}, state, { getProjectMortgage: payload });
    case GET_PROJECT_MORTGAGE_EXPORT:
      return Object.assign({}, state, {
        getProjectMortgageExport: payload
      });
    case GET_PROJECT_MORTGAGE_DETAILS:
      return Object.assign({}, state, {
        getProjectMortgageDetails: payload
      });
    case GET_LOAN_PROCESS_STATUS_EXPORT:
      return Object.assign({}, state, {
        getLoanProcessStatusExport: payload
      });
    case GET_LOAN_PROCESS_STATUS:
      return Object.assign({}, state, { getLoanProcessStatus: payload });
    case GET_LOAN_PROCESS_PLAN_DETAIL:
      return Object.assign({}, state, {
        getLoanProcessPlanDetail: payload
      });
    case GET_PROJECT_MORTGAGE_ELIGIBLE_FILE:
      return Object.assign({}, state, {
        getProjectMortgageEligibleFile: payload
      });
    case GET_LOAN_PROCESS_STATUS_FOR_UPDATE:
      return Object.assign({}, state, {
        getLoanProcessStatusForUpdate: payload
      });
    case GET_PROJECT_LOAN_FILTER_PROJECT:
      return Object.assign({}, state, {
        getProjectLoanFilterProject: payload
      });
    case GET_PROJECT_LOAN_FILTER_BANK:
      return Object.assign({}, state, {
        getProjectLoanFilterBank: payload
      });
    case GET_LOAN_PROCESS_PLAN_FILTER_PROJECT:
      return Object.assign({}, state, {
        getLoanProcessPlanFilterProject: payload
      });
    case GET_LOAN_PROCESS_PLAN_FILTER_BANK:
      return Object.assign({}, state, {
        getLoanProcessPlanFilterBank: payload
      });
    case GET_LOAN_PROCESS_PLAN_FILTER_PROCESS:
      return Object.assign({}, state, {
        getLoanProcessPlanFilterProcess: payload
      });
    case GET_LOAN_PROCESS_PLAN_FILTER_PANEL:
      return Object.assign({}, state, {
        getLoanProcessPlanFilterPanel: payload
      });
    case GET_LOAN_PROCESS_PLAN_FOR_QUERY_CREATE:
      return Object.assign({}, state, {
        getLoanProcessPlanForQueryCreate: payload
      });
    case GET_LOAN_PROCESS_PLAN_QUERY:
      return Object.assign({}, state, {
        getLoanProcessPlanQueryList: payload
      });
    case GET_LOAN_PROCESS_PLAN_QUERY_EXPORT:
      return Object.assign({}, state, {
        getLoanProcessPlanQueryExport: payload
      });
    case GET_LOAN_PROCESS_PLAN_QUERY_DETAIL:
      return Object.assign({}, state, {
        getLoanProcessPlanQueryDetail: payload
      });
    case GET_LOAN_PROCESS_PLAN_QUERY_FILTER_PROJECT:
      return Object.assign({}, state, {
        getLoanProcessPlanQueryFilterProject: payload
      });
    case GET_LOAN_PROCESS_PLAN_QUERY_FILTER_BANK:
      return Object.assign({}, state, {
        getLoanProcessPlanQueryFilterBank: payload
      });
    case GET_LOAN_PROCESS_PLAN_QUERY_FILTER_PANEL:
      return Object.assign({}, state, {
        getLoanProcessPlanQueryFilterPanel: payload
      });
    case GET_LOAN_PROCESS_PLAN_QUERY_FILTER_RESPONSIBLE:
      return Object.assign({}, state, {
        getLoanProcessPlanQueryFilterResponsible: payload
      });
    case GET_LOAN_PROCESS_PLAN_QUERY_FILTER_ACCOUNTABLE:
      return Object.assign({}, state, {
        getLoanProcessPlanQueryFilterAccountable: payload
      });
    case GET_LOAN_PROCESS_PLAN_QUERY_FILTER_PROCESS:
      return Object.assign({}, state, {
        getLoanProcessPlanQueryFilterProcess: payload
      });
    case GET_LOAN_PROCESS_PLAN_FILTER_RESPONSIBLE:
      return Object.assign({}, state, {
        getLoanProcessPlanFilterResponsible: payload
      });
    case GET_LOAN_PROCESS_PLAN_FILTER_ACCOUNTABLE:
      return Object.assign({}, state, {
        getLoanProcessPlanFilterAccountable: payload
      });
    case GET_LOAN_PROCESS_PLAN_QUERY_TEMPLATE:
      return Object.assign({}, state, {
        getLoanProcessPlanQueryTemplete: payload
      });
    case GET_LOAN_PROCESS_PLAN_QUERY_REPORT:
      return Object.assign({}, state, {
        getLoanProcessPlanQueryReport: payload
      });

    // Vendor Nithish

    case GET_VENDOR:
      return Object.assign({}, state, { getVendor: payload });
    case GET_CONSTITUTION_OF_FIRM:
      return Object.assign({}, state, { getConstitutionOfFirm: payload });
    case GET_VENDOR_DOCUMENTS:
      return Object.assign({}, state, { getVendorDocuments: payload });
    case GET_VENDOR_DOCUMENT_TYPE:
      return Object.assign({}, state, { getVendorDocumentType: payload });
    case GET_VENDOR_SERVICE:
      return Object.assign({}, state, { getVendorService: payload });
    case GET_VENDOR_SERVICE_MASTER:
      return Object.assign({}, state, {
        getVendorServiceMaster: payload
      });
    case GET_VENDOR_CONTACT:
      return Object.assign({}, state, { getVendorContact: payload });
    case GET_VENDOR_ACCOUNT:
      return Object.assign({}, state, { getVendorAccount: payload });
    case GET_VENDOR_ACCOUNT_DOCUMENT_TYPE:
      return Object.assign({}, state, {
        getVendorAccountDocumentType: payload
      });
    case GET_VENDOR_ADDRESS:
      return Object.assign({}, state, { getVendorAddress: payload });
    case GET_STATE:
      return Object.assign({}, state, { getState: payload });
    case GET_VENDOR_ACTION_HISTORY:
      return Object.assign({}, state, {
        getVendorActionHistory: payload
      });
    case GET_ACCOUNT_PAYMENT_FILTER_COMPANY:
      return Object.assign({}, state, {
        getAccountPaymentFilterCompany: payload
      });
    case GET_ACCOUNT_PAYMENT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getAccountPaymentFilterProject: payload
      });
    case GET_ACCOUNT_PAYMENT_FILTER_REQUESTED_BY:
      return Object.assign({}, state, {
        getAccountPaymentFilterRequestedBy: payload
      });
    case GET_ACCOUNT_PAYMENT_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getAccountPaymentFilterCategory: payload
      });
    case GET_VENDOR_DETAILS:
      return Object.assign({}, state, { getVendorDetails: payload });
    case GET_CHANNEL_PATNER_FILTER_RELATIONSHIP:
      return Object.assign({}, state, {
        getChannelPartnerFilterRelationship: payload
      });

    case GET_VENDOR_CHANGE_REQUEST:
      return Object.assign({}, state, {
        getVendorChangeRequest: payload
      });
    case GET_VENDOR_CHANGE_REQUEST_DETAILS:
      return Object.assign({}, state, {
        getVendorChangeRequestDetails: payload
      });
    case GET_CIVIL_PROJECT_BILL_ACCOUNT:
      return Object.assign({}, state, {
        getCivilProjectBillAccount: payload
      });
    case GET_CIVIL_PROJECT_BILL_ACCOUNT_EXPORT:
      return Object.assign({}, state, {
        getCivilProjectBillAccountExport: payload
      });
    case GET_VENDOR_EXPORT:
      return Object.assign({}, state, {
        getVendorExport: payload
      });
    case GET_CHANNEL_PARTNER:
      return Object.assign({}, state, {
        getChannelPartner: payload
      });
    case GET_CHANNEL_PARTNER_EXPORT:
      return Object.assign({}, state, {
        getChannelPartnerExport: payload
      });
    case GET_GOVT_FEES:
      return Object.assign({}, state, { getGovernmentFees: payload });

    case GET_GOVT_FEES_PROCESS_PLAN:
      return Object.assign({}, state, {
        getGovernmentFeesProcessPlan: payload
      });

    case GET_GOVERNMENT_DETAIL:
      return Object.assign({}, state, {
        getGovernmentFeesDetail: payload
      });

    case GET_GOVT_FEES_PROCESS_ITEM:
      return Object.assign({}, state, {
        getGovernmentFeesProcessItem: payload
      });
    case GET_GOVT_FEES_ITEM:
      return Object.assign({}, state, { getGovernmentFeesItem: payload });
    case GET_GOVT_FEES_MODE_CATEGORY:
      return Object.assign({}, state, {
        getGovernmentFeesModeCategory: payload
      });
    case GET_GOVT_FEES_PROJECT_FILTER:
      return Object.assign({}, state, {
        getGovernmentFeesFilterProject: payload
      });

    case GET_GOVT_FEES_PROCESS_FILTER:
      return Object.assign({}, state, {
        getGovernmentFeesFilterProcess: payload
      });

    case GET_GOVT_FEES_FILTER_COMPANY:
      return Object.assign({}, state, {
        getGovernmentFeesFilterCompany: payload
      });
    case GET_GOVT_FEES_FILTER_REQUESTED_BY:
      return Object.assign({}, state, {
        getGovernmentFeesFilterRequestedBy: payload
      });
    case GET_GOVT_FEE_SURVEY_NUMBER:
      return Object.assign({}, state, {
        getGovernmentFeesSurveyNumber: payload
      });
    case GET_RETENTION_PERCENTAGE:
      return Object.assign({}, state, {
        getRetentionPercentage: payload
      });
    case GET_RETENTION_PERCENTAGE_FILTER_BILL_CATEGORY:
      return Object.assign({}, state, {
        getRetentionPercentageFilterBillCategory: payload
      });

    case GET_RETENTION_PERCENTAGE_EXPORT:
      return Object.assign({}, state, {
        getRetentionPercentageExport: payload
      });
    case GET_BILL_CATEGORY:
      return Object.assign({}, state, {
        getBillCategory: payload
      });
    case GET_GOVT_FEES_TASK_PLAN:
      return Object.assign({}, state, {
        getGovernmentFeesTaskPlan: payload
      });
    //Vendor Ledger
    case GET_VENDOR_LEDGER:
      return Object.assign({}, state, {
        getVendorLedger: payload
      });
    case GET_VENDOR_LEDGER_DETAILS:
      return Object.assign({}, state, {
        getVendorLedgerDetails: payload
      });

    case GET_PAYMENT_REQUEST:
      return Object.assign({}, state, {
        getPaymentRequest: payload
      });
    case GET_PAYMENT_REQUEST_EXPORT:
      return Object.assign({}, state, {
        getPaymentRequestExport: payload
      });
    case GET_PAYMENT_REQUEST_PAID:
      return Object.assign({}, state, {
        getPaymentRequestPaid: payload
      });
    case GET_PAYMENT_REQUEST_PAID_FILTER_COMPANY:
      return Object.assign({}, state, {
        getPaymentRequestPaidFilterCompany: payload
      });
    case GET_PAYMENT_REQUEST_PAID_EXPORT:
      return Object.assign({}, state, {
        getPaymentRequestPaidExport: payload
      });
    case GET_PAYMENT_REQUEST_PAID_DETAIL:
      return Object.assign({}, state, {
        getPaymentRequestPaidDetail: payload
      });
    case GET_PAYMENT_REQUEST_FILTER_PROJECT:
      return Object.assign({}, state, {
        getPaymentRequestFilterProject: payload
      });
    case GET_PAYMENT_REQUEST_FILTER_VENDOR:
      return Object.assign({}, state, {
        getPaymentRequestFilterVendor: payload
      });
    case GET_PAYMENT_REQUEST_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getPaymentRequestFilterCategory: payload
      });
    case GET_PAYMENT_REQUEST_FILTER_REQUESTED_BY:
      return Object.assign({}, state, {
        getPaymentRequestApprovalFilterRequestedBy: payload
      });
    case GET_PAYMENT_REQUEST_FILTER_COMPANY:
      return Object.assign({}, state, {
        getPaymentRequestFilterComapny: payload
      });
    case GET_VENDOR_LEDGER_EXPORT:
      return Object.assign({}, state, {
        getVendorLedgerExport: payload
      });

    case GET_PAYMENT_REQUEST_DETAIL:
      return Object.assign({}, state, {
        getPaymentRequestDetail: payload
      });

    case GET_PAYMENT_REQUEST_APPROVAL:
      return Object.assign({}, state, {
        getPaymentRequestApproval: payload
      });

    case GET_PAYMENT_REQUEST_APPROVAL_EXPORT:
      return Object.assign({}, state, {
        getPaymentRequestApprovalExport: payload
      });

    case GET_PAYMENT_REQUEST_APPROVAL_FILTER_PROJECT:
      return Object.assign({}, state, {
        getPaymentRequestApprovalFilterProject: payload
      });

    case GET_PAYMENT_REQUEST_APPROVAL_FILTER_VENDOR:
      return Object.assign({}, state, {
        getPaymentRequestApprovalFilterVendor: payload
      });

    case GET_PAYMENT_REQUEST_APPROVAL_FILTER_COMPANY:
      return Object.assign({}, state, {
        getPaymentRequestApprovalFilterCompany: payload
      });

    case GET_PAYMENT_REQUEST_APPROVAL_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getPaymentRequestApprovalFilterCategory: payload
      });

    case GET_ACCOUNT_CHEQUE_NUMBER:
      return Object.assign({}, state, {
        getAccountChequeNumber: payload
      });

    case VENDOR_LEDGER_ITEM:
      return Object.assign({}, state, {
        getVendorLedgerItem: payload
      });

    case GET_VENDOR_LEDGER_ITEM_EXPORT:
      return Object.assign({}, state, {
        getVendorLedgerItemExport: payload
      });
    case GET_VENDOR_LEDGER_ITEM_PRINT:
      return Object.assign({}, state, {
        getVendorLedgerItemPrint: payload
      });

    case GET_VENDOR_LEDGER_FILTER_VENDOR:
      return Object.assign({}, state, {
        getVendorLedgerFilterVendor: payload
      });

    case GET_VENDOR_LEDGER_FILTER_COMPANY:
      return Object.assign({}, state, {
        getVendorLedgerFilterCompany: payload
      });

    case GET_VENDOR_LEDGER_ITEM_FILTER_VENDOR:
      return Object.assign({}, state, {
        getVendorLedgerItemFilterVendor: payload
      });

    case GET_VENDOR_LEDGER_ITEM_FILTER_COMPANY:
      return Object.assign({}, state, {
        getVendorLedgerItemFilterCompany: payload
      });

    case GET_VENDOR_LEDGER_ITEM_FILTER_PROJECT:
      return Object.assign({}, state, {
        getVendorLedgerItemFilterProject: payload
      });

    case GET_VENDOR_LEDGER_ITEM_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getVendorLedgerItemForCategory: payload
      });

    case GET_VENDOR_ACCOUNT_FOR_PAYMENT_REQUEST:
      return Object.assign({}, state, {
        getVendorAccountForPaymentRequest: payload
      });

    case GET_CATEGORY_FOR_PAYMENT_REQUEST:
      return Object.assign({}, state, {
        getCategoryForPaymentRequest: payload
      });

    case GET_VENDOR_PAYMENT_INFO_FOR_PAYMENT_REQUEST:
      return Object.assign({}, state, {
        getVendorPaymentInfoForPaymentRequest: payload
      });

    case GET_VENDOR_PO_WO_FOR_PAYMENT_REQUEST:
      return Object.assign({}, state, {
        getVendorPoWoForPaymentRequest: payload
      });

    case GET_COMPANY_FOR_PAYMENT_REQUEST:
      return Object.assign({}, state, {
        getCompanyForPaymentRequest: payload
      });
    case GET_PROJECT_FOR_PAYMENT_REQUEST:
      return Object.assign({}, state, {
        getProjectForPaymentRequest: payload
      });
    case GET_VENDOR_FOR_PAYMENT_REQUEST:
      return Object.assign({}, state, {
        getVendorForPaymentRequest: payload
      });
    //TDS Master
    case GET_TDS_DEDUCTION:
      return Object.assign({}, state, {
        getTdsDeduction: payload
      });
    case GET_TDS_DEDUCTION_EXPORT:
      return Object.assign({}, state, {
        getTdsDeductionExport: payload
      });

    case GET_TDS_DEDUCTION_FILTER_VENDOR:
      return Object.assign({}, state, {
        getTdsDeductionFilterVendor: payload
      });
    case GET_TDS_DEDUCTION_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getTdsDeductionFilterCategory: payload
      });
    //Expenses Invoice
    case GET_COST_CENTER_EXPORT:
      return Object.assign({}, state, {
        getCostCenterExport: payload
      });
    case GET_COST_CENTER_CATEGORY_EXPORT:
      return Object.assign({}, state, {
        getCostCenterCategoryExport: payload
      });
    case GET_PAYMENT_CATEGORY_MASTER_EXPORT:
      return Object.assign({}, state, {
        getPaymentCategoryMasterExport: payload
      });
    case GET_COST_CENTER:
      return Object.assign({}, state, { getCostCenter: payload });

    case GET_ITEM_FOR_EXPENSES:
      return Object.assign({}, state, {
        getItemForExpenses: payload
      });
    case GET_EXPENSES_INVOICE:
      return Object.assign({}, state, { getExpensesInvoice: payload });
    case GET_EXPENSES_INVOICE_EXPORT:
      return Object.assign({}, state, { getExpensesInvoiceExport: payload });
    case GET_EXPENSES_INVOICE_DETAIL:
      return Object.assign({}, state, { getExpensesInvoiceDetail: payload });
    case GET_EXPENSES_INVOICE_FILTER_PROJECT:
      return Object.assign({}, state, {
        getExpensesInvoiceFilterProject: payload
      });
    case GET_EXPENSES_INVOICE_FILTER_VENDOR:
      return Object.assign({}, state, {
        getExpensesInvoiceFilterVendor: payload
      });
    case GET_EXPENSES_INVOICE_FILTER_COMPANY:
      return Object.assign({}, state, {
        getExpensesInvoiceFilterCompany: payload
      });
    case GET_EXPENSES_INVOICE_FILTER_COST_CENTER:
      return Object.assign({}, state, {
        getExpensesInvoiceFilterCostCenter: payload
      });

    //compony map
    case GET_COMPANY_ACCOUNT_MAP:
      return Object.assign({}, state, {
        getCompanyAccountMap: payload
      });

    case GET_COMPANY_ACCOUNT_MAP_FILTER_COMPANY:
      return Object.assign({}, state, {
        getCompanyAccountMapFilterCompany: payload
      });

    case GET_COMPNAY_ACCOUNT_MAP_FILTER_BANK:
      return Object.assign({}, state, {
        getCompanyAccountMapFilterBank: payload
      });
    case GET_COMPANY_ACCOUNT_MAP_EXPORT:
      return Object.assign({}, state, {
        getCompanyAccountMapExport: payload
      });
    case GET_SERVICE_FOR_VENDOR:
      return Object.assign({}, state, { getServiceForVendor: payload });

    //loan summary
    case GET_PROJECT_LONE_SUMMARY:
      return Object.assign({}, state, {
        getProjectLoanSummary: payload
      });
    case GET_PROJECT_LONE_SUMMARY_EXPORT:
      return Object.assign({}, state, {
        getProjectLoanSummaryExport: payload
      });
    case GET_SURVEY_NUMBER_FOR_LOAN_QUERY:
      return Object.assign({}, state, {
        getSurveyNumberForLoanQuery: payload
      });

    //petty cash
    case GET_PETTY_CASH:
      return Object.assign({}, state, { getPettyCash: payload });
    case GET_PETTY_CASH_EXPORT:
      return Object.assign({}, state, { getPettyCashExport: payload });

    case GET_PETTY_CASH_DETAIL:
      return Object.assign({}, state, { getPettyCashDetails: payload });
    case GET_PETTY_CASH_FILTER_PROJECT:
      return Object.assign({}, state, {
        getPettyCashFilterProject: payload
      });

    case GET_PETTY_CASH_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getPettyCashFilterDepartment: payload
      });

    case GET_PETTY_CASH_FILTER_REQUESTED_BY:
      return Object.assign({}, state, {
        getPettyCashFilterRequestedBy: payload
      });

    case GET_PETTY_CASH_FILTER_COMPANY:
      return Object.assign({}, state, {
        getPettyCashFilterCompany: payload
      });

    case GET_COST_CENTER_FOR_PETTY_CASH:
      return Object.assign({}, state, {
        getCostCenterForPettyCash: payload
      });
    case GET_PAYMENT_REQUEST_PAID_ITEM:
      return Object.assign({}, state, {
        getPaymentRequestPaidItem: payload
      });

    case GET_PAYMENT_REQUEST_PAID_ITEM_EXPORT:
      return Object.assign({}, state, {
        getPaymentRequestPaidItemExport: payload
      });

    case GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_COMPANY:
      return Object.assign({}, state, {
        getPaymentRequestPaidItemFilterCompany: payload
      });

    case GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_VENDOR:
      return Object.assign({}, state, {
        getPaymentRequestPaidItemFilterVendor: payload
      });

    case GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_BANK:
      return Object.assign({}, state, {
        getPaymentRequestPaidItemFilterBank: payload
      });

    case GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_ACCOUNT:
      return Object.assign({}, state, {
        getPaymentRequestPaidItemFilterAccount: payload
      });

    case GET_PAYMENT_REQUEST_PAID_ITEM_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getPaymentRequestPaidItemFilterCategory: payload
      });

    case GET_EXPENSES_INVOICE_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getExpensesInvoiceFilterCategory: payload
      });

    case GET_PAYMENT_CATEGORY_MASTER:
      return Object.assign({}, state, {
        getPaymentCategoryMaster: payload
      });
    case GET_SALARY_JV:
      return Object.assign({}, state, {
        getSalaryJV: payload
      });
    case GET_SALARY_EMPLOYER_PF_DETAIL:
      return Object.assign({}, state, {
        getSalaryEmployerPfDetail: payload
      });
    case GET_SALARY_EMPLOYER_ESI_DETAIL:
      return Object.assign({}, state, {
        getSalaryEmployerEsiDetail: payload
      });

    case GET_SALARY_ADVANCE_DETAIL:
      return Object.assign({}, state, {
        getSalaryAdvanceDetail: payload
      });
    case GET_PAYMENT_CATEGORY_FOR_EXPENSE:
      return Object.assign({}, state, {
        getPaymentCategoryForExpense: payload
      });
    case GET_SALARY_JV_DETAIL:
      return Object.assign({}, state, {
        getSalaryJvDetail: payload
      });

    case GET_SALARY_JV_EXPORT:
      return Object.assign({}, state, {
        getSalaryJVExport: payload
      });

    case GET_SALARY_JV_FILTER_COMPANY:
      return Object.assign({}, state, {
        getSalaryJVFilterCompany: payload
      });

    case GET_COST_CENTER_CATEGORY:
      return Object.assign({}, state, {
        getCostCenterCategory: payload
      });

    case GET_COST_CENTER_MASTER:
      return Object.assign({}, state, {
        getCostCenterMaster: payload
      });

    case GET_TDS_FOR_BILL:
      return Object.assign({}, state, {
        getTdsForBill: payload
      });

    case GET_EXPENSES_INVOICE_ACCOUNT:
      return Object.assign({}, state, { getExpensesInvoiceAccount: payload });
    case GET_EXPENSES_INVOICE_ACCOUNT_EXPORT:
      return Object.assign({}, state, {
        getExpensesInvoiceAccountExport: payload
      });
    case GET_EXPENSES_INVOICE_ACCOUNT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getExpenseInvoiceAccountFilterProject: payload
      });
    case GET_EXPENSES_INVOICE_ACCOUNT_FILTER_VENDOR:
      return Object.assign({}, state, {
        getExpenseInvoiceAccountFilterVendor: payload
      });
    case GET_EXPENSES_INVOICE_ACCOUNT_FILTER_COMPANY:
      return Object.assign({}, state, {
        getExpenseInvoiceAccountFilterCompany: payload
      });
    case GET_EXPENSES_INVOICE_ACCOUNT_FILTER_COSTCENTER:
      return Object.assign({}, state, {
        getExpenseInvoiceAccountFilterCostCenter: payload
      });
    case GET_EXPENSES_INVOICE_ACCOUNT_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getExpenseInvoiceAccountFilterCategory: payload
      });

    case GET_STOCK_COMPANY:
      return Object.assign({}, state, {
        getStockCompany: payload
      });
    case GET_STOCK_COMPANY_EXPORT:
      return Object.assign({}, state, {
        getStockCompanyExport: payload
      });
    case GET_STOCK_COMPANY_DETAILS:
      return Object.assign({}, state, {
        getCompanyDetail: payload
      });
    case GET_DIRECTOR_TYPE:
      return Object.assign({}, state, {
        getDirectorType: payload
      });
    case GET_SALARY_EXPENSE_OTHER_DEDUCTION:
      return Object.assign({}, state, {
        getSalaryExpenseOtherDeduction: payload
      });
    case GET_SALARY_EXPENSE_OTHER_DEDUCTION_EXPORT:
      return Object.assign({}, state, {
        getSalaryExpenseOtherDeductionExport: payload
      });

    //Payment Receit
    case GET_PAYMENT_RECIEVED:
      return Object.assign({}, state, {
        getPaymentRecieved: payload
      });
    case GET_PAYMENT_RECIEVED_EXPORT:
      return Object.assign({}, state, {
        getPaymentRecievedExport: payload
      });
    case GET_CUSTOMER_FOR_PAYMENT_RECIEVED:
      return Object.assign({}, state, {
        getCustomerForPaymentRecieved: payload
      });
    case GET_PAYMENT_RECIEVED_FILTER_COMPANY:
      return Object.assign({}, state, {
        getPaymentRecievedFilterCompany: payload
      });
    case GET_PAYMENT_RECIEVED_FILTER_PROJECT:
      return Object.assign({}, state, {
        getPaymentRecievedFilterProject: payload
      });
    case GET_PAYMENT_RECIEVED_FILTER_ACCOUNT:
      return Object.assign({}, state, {
        getPaymentRecievedFilterAccount: payload
      });
    case GET_PAYMENT_RECIEVED_FILTER_CUSTOMER:
      return Object.assign({}, state, {
        getPaymentRecievedFilterCustomer: payload
      });
    case GET_PAYMENT_RECIEVED_FILTER_BANK:
      return Object.assign({}, state, {
        getPaymentRecievedFilterBank: payload
      });
    case GET_PAYMENT_RECIEVED_DETAIL:
      return Object.assign({}, state, {
        getPaymentRecievedDetail: payload
      });
    case GET_PAYMENT_RECEIPT_FILTER_SITE_NUMBER:
      return Object.assign({}, state, {
        getPaymentReceiptFilterSiteNumber: payload
      });
    case GET_PAYMENT_RECEIPT_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getPaymentReceiptFilterCategory: payload
      });
    case GET_PAYMENT_RECIEVED_FILTER_STATUS:
      return Object.assign({}, state, {
        getPaymentRecievedFilterStatus: payload
      });
    case GET_VEHICLE_FUEL:
      return Object.assign({}, state, {
        getVehicleFuel: payload
      });

    case GET_VEHICLE_FUEL_EXPORT:
      return Object.assign({}, state, {
        getVehicleFuelExport: payload
      });

    case GET_VEHICLE_FUEL_DETAILS:
      return Object.assign({}, state, {
        getVehicleFuelDetails: payload
      });

    case GET_VEHICLE_FUEL_FILTER_EMPLOYEE:
      return Object.assign({}, state, {
        getVehicleFuelFilterEmployee: payload
      });

    case GET_VEHICLE_FUEL_FILTER_PROJECT:
      return Object.assign({}, state, {
        getVehicleFuelFilterProject: payload
      });

    case GET_PAYMENT_STATUS:
      return Object.assign({}, state, {
        getPaymentStatus: payload
      });
    case GET_VENDOR_LEDGER_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getVendorLedgerFilterCategory: payload
      });
    case GET_CHEQUE_BOOK:
      return Object.assign({}, state, {
        getChequeBook: payload
      });
    case GET_CHEQUE_BOOK_EXPORT:
      return Object.assign({}, state, {
        getChequeBookExport: payload
      });
    case GET_CHEQUE_BOOK_FILTER_COMPANY:
      return Object.assign({}, state, {
        getChequeBookFilterCompany: payload
      });
    case GET_CHEQUE_BOOK_FILTER_ACCOUNT:
      return Object.assign({}, state, {
        getChequeBookFilterAccount: payload
      });
    case GET_CHEQUE_BOOK_USAGE:
      return Object.assign({}, state, {
        getChequeBookUsage: payload
      });
    case GET_CHEQUE_BOOK_USAGE_EXPORT:
      return Object.assign({}, state, {
        getChequeBookUsageExport: payload
      });
    case GET_CHEQUE_BOOK_USAGE_FILTER_COMPANY:
      return Object.assign({}, state, {
        getChequeBookUsageFilterCompany: payload
      });
    case GET_CHEQUE_BOOK_USAGE_FILTER_ACCOUNT:
      return Object.assign({}, state, {
        getChequeBookUsageFilterAccount: payload
      });
    case GET_CHEQUE_BOOK_USAGE_FILTER_STATUS:
      return Object.assign({}, state, {
        getChequeBookUsageFilterStatus: payload
      });
    case GET_CHEQUE_BOOK_STATUS:
      return Object.assign({}, state, {
        getChequeBookStatus: payload
      });
    case GET_CHEQUE_BOOK_NUMBER_FOR_CHEQUE:
      return Object.assign({}, state, {
        getChequeBookNumberForCheque: payload
      });
    case GET_COMPANY_FOR_CHEQUE_USAGE:
      return Object.assign({}, state, {
        getCompanyForChequeUsage: payload
      });
    case GET_CHEQUE_BOOK_DETAILS:
      return Object.assign({}, state, {
        getChequeBookDetail: payload
      });
    case GET_CHEQUE_BOOK_USAGE_DETAILS:
      return Object.assign({}, state, {
        getChequeBookUsageDetail: payload
      });
    case GET_CARD:
      return Object.assign({}, state, {
        getCard: payload
      });
    case GET_CARD_EXPORT:
      return Object.assign({}, state, {
        getCardExport: payload
      });
    case IMPORT_CHANNEL_PARTNER:
      return Object.assign({}, state, {
        importChannelPartner: payload
      });

    case GET_DEMAND_DRAFT_REQUEST:
      return Object.assign({}, state, {
        getDemandraftRequest: payload
      });

    case GET_DEMAND_DRAFT_REQUEST_DETAIL:
      return Object.assign({}, state, {
        getDemandraftRequestDetail: payload
      });

    case GET_DEMAND_DRAFT_REQUEST_FILTER_PROJECT:
      return Object.assign({}, state, {
        getDemandraftRequestFilterProject: payload
      });
    case GET_DEMAND_DRAFT_REQUEST_FILTER_VENDOR:
      return Object.assign({}, state, {
        getDemandraftRequestFilterVendor: payload
      });
    //vendor service filter
    case GET_VENDOR_FILTER_SERVICE:
      return Object.assign({}, state, {
        getVendorFilterService: payload
      });

    //pettey cash

    case GET_PETTY_CASH_ACCOUNTS:
      return Object.assign({}, state, {
        getPettyCashAccounts: payload
      });
    case GET_PETTY_CASH_ACCOUNTS_EXPORT:
      return Object.assign({}, state, {
        getPettyCashAccountsExport: payload
      });

    case GET_PETTY_CASH_ACCOUNTS_FILTER_PROJECT:
      return Object.assign({}, state, {
        getPettyCashAccountsFilterProject: payload
      });
    case GET_PETTY_CASH_ACCOUNTS_FILTER_COMPANY:
      return Object.assign({}, state, {
        getPettyCashAccountsFilterCompany: payload
      });
    case GET_PETTY_CASH_ACCOUNTS_FILTER_REQUESTED_BY:
      return Object.assign({}, state, {
        getPettyCashAccountsFilterRequestedBy: payload
      });
    case GET_PETTY_CASH_ACCOUNTS_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getPettyCashAccountsFilterDepartment: payload
      });
    case GET_PETTY_CASH_SETTING:
      return Object.assign({}, state, {
        getPettyCashSetting: payload
      });
    // Accounts Director (SVM)
    case GET_DIRECTOR:
      return Object.assign({}, state, {
        getDirector: payload
      });
    case GET_DIRECTOR_DETAIL:
      return Object.assign({}, state, {
        getDirectorDetail: payload
      });
    case GET_DOCUMENT_TYPE:
      return Object.assign({}, state, {
        getDocumentTypeForDirector: payload
      });

    // Accounts Din Verififcation
    case GET_DIN_VERIFICATION:
      return Object.assign({}, state, {
        getDinVerification: payload
      });
    case GET_DIN_VERIFICATION_DETAIL:
      return Object.assign({}, state, {
        getDinVerificationDetail: payload
      });

    case GET_COMPANY_FOR_ASSET_GROUP:
      return Object.assign({}, state, {
        getCompanyForAssetGroup: payload
      });

    case GET_PAYMENT_RECEIVED_STATUS:
      return Object.assign({}, state, {
        getPaymentReceivedStatus: payload
      });
    case GET_STATUS_FOR_PAYMENT_RECEIPT:
      return Object.assign({}, state, {
        getStatusForPaymentReceipt: payload
      });
    case GET_REASON_FOR_NOT_REALIZED_PAYMENT:
      return Object.assign({}, state, {
        getReasonForNotRealizedPayment: payload
      });
    case GET_LEASE:
      return Object.assign({}, state, {
        getLease: payload
      });
    case GET_LEASE_FILTER_LESSEE:
      return Object.assign({}, state, {
        getLeaseFilterLessee: payload
      });
    case GET_LEASE_FILTER_LESSOR:
      return Object.assign({}, state, {
        getLeaseFilterLessor: payload
      });
    case GET_LEASE_DETAIL:
      return Object.assign({}, state, {
        getLeaseDetail: payload
      });
    case GET_RERA_APPLICATION:
      return Object.assign({}, state, {
        getReraApplication: payload
      });
    case GET_RERA_APPLICATION_EXPORT:
      return Object.assign({}, state, {
        getReraApplicationExport: payload
      });
    case GET_RERA_AUTHORITIES:
      return Object.assign({}, state, {
        getReraAuthorities: payload
      });
    case GET_RERA_APPLICATION_DETAIL:
      return Object.assign({}, state, {
        getReraApplicationDetail: payload
      });
    case GET_RERA_QUERY:
      return Object.assign({}, state, {
        getReraQuery: payload
      });
    case GET_RERA_QUERY_EXPORT:
      return Object.assign({}, state, {
        getReraQueryExport: payload
      });
    case GET_RERA_APPLICATION_PROJECT:
      return Object.assign({}, state, {
        getReraApplicationProject: payload
      });
    case GET_RERA_QUERY_PROJECT:
      return Object.assign({}, state, {
        getReraQueryProject: payload
      });
    case GET_RERA_QUERY_DETAILS:
      return Object.assign({}, state, {
        getReraQueryDetail: payload
      });
    case GET_RERA_QUERY_FILTER_PROJECT:
      return Object.assign({}, state, {
        getReraQueryFilterProject: payload
      });
    case GET_RERA_APPLICATION_FILTER_PROJECT:
      return Object.assign({}, state, {
        getReraApplicationFilterProject: payload
      });
    case GET_RERA_QUERY_FILTER_RESPONSIBLE:
      return Object.assign({}, state, {
        getReraQueryFilterResponsible: payload
      });
    case GET_RERA_QUERY_FILTER_ACCOUNTABLE:
      return Object.assign({}, state, {
        getReraQueryFilterAccountable: payload
      });
    case GET_RERA_FILING:
      return Object.assign({}, state, {
        getReraFiling: payload
      });
    case GET_RERA_FILING_EXPORT:
      return Object.assign({}, state, {
        getReraFilingExport: payload
      });
    case GET_RERA_FILING_DETAIL:
      return Object.assign({}, state, {
        getReraFilingDetail: payload
      });
    case GET_RERA_FILING_FILTER_PROJECT:
      return Object.assign({}, state, {
        getReraFilingFilterProject: payload
      });
    case GET_CARD_DETAILS:
      return Object.assign({}, state, {
        getCardDetails: payload
      });
    case GET_LOAN_CATEGORY:
      return Object.assign({}, state, {
        getLoanCategory: payload
      });
    case GET_LOAN_CATEGORY_EXPORT:
      return Object.assign({}, state, {
        getLoanCategoryExport: payload
      });
    case GET_LOAN_SECURITY:
      return Object.assign({}, state, {
        getLoanSecurity: payload
      });
    case GET_LOAN_SECURITY_EXPORT:
      return Object.assign({}, state, {
        getLoanSecurityExport: payload
      });
    case GET_LOAN_SECURITY_FILTER_COMPANY:
      return Object.assign({}, state, {
        getLoanSecurityFilterCompany: payload
      });
    case GET_LOAN_SECURITY_FILTER_BANK:
      return Object.assign({}, state, {
        getLoanSecurityFilterBank: payload
      });
    case GET_LOAN:
      return Object.assign({}, state, {
        getLoan: payload
      });
    case GET_LOAN_EXPORT:
      return Object.assign({}, state, {
        getLoanExport: payload
      });
    case GET_LOAN_DETAILS:
      return Object.assign({}, state, {
        getLoanDetail: payload
      });
    case GET_LOAN_PENALTY_REASON:
      return Object.assign({}, state, {
        getLoanPenaltyReason: payload
      });
    case GET_LOAN_FILTER_COMPANY:
      return Object.assign({}, state, {
        getLoanFilterCompany: payload
      });
    case GET_LOAN_FILTER_BANK:
      return Object.assign({}, state, {
        getLoanFilterBank: payload
      });
    case GET_LOAN_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getLoanFilterCategory: payload
      });
    case GET_LAND_FOR_LOAN_SECURITY:
      return Object.assign({}, state, {
        getLandForLoanSecurity: payload
      });
    case GET_SITE_FOR_LOAN_SECURITY:
      return Object.assign({}, state, {
        getSiteForLoanSecurity: payload
      });
    case GET_LOAN_SECURITY_FILTER_PROJECT:
      return Object.assign({}, state, {
        getLoanSecurityFilterProject: payload
      });
    case GET_LOAN_SECURITY_FILTER_LENDER:
      return Object.assign({}, state, {
        getLoanSecurityFilterLender: payload
      });
    case GET_LOAN_FILTER_LENDER:
      return Object.assign({}, state, {
        getLoanFilterLender: payload
      });
    // cheque usage
    case GET_CHEQUE_BOOK_USAGE_REPORT:
      return Object.assign({}, state, {
        getChequeBookUsageReport: payload
      });
    case GET_CHEQUE_BOOK_USAGE_REPORT_DETAILS:
      return Object.assign({}, state, {
        getChequeBookUsageReportDetail: payload
      });
    case GET_CHEQUE_BOOK_USAGE_REPORT_DETAILS_EXPORT:
      return Object.assign({}, state, {
        getChequeBookUsageReportDetailExport: payload
      });
    // TDS Section (SVM)
    case GET_TDS_SECTION:
      return Object.assign({}, state, {
        getTdsSection: payload
      });
    case GET_TDS_SECTION_EXPORT:
      return Object.assign({}, state, {
        getTdsSectionExport: payload
      });
    case GET_TDS_SECTION_DETAIL:
      return Object.assign({}, state, {
        getTdsSectionDetail: payload
      });
    case GET_TDS_DEDUCTION_DETAIL:
      return Object.assign({}, state, {
        getTdsDeductionDetail: payload
      });

    case GET_VENDOR_FOR_TDS_DEDUCTION:
      return Object.assign({}, state, {
        getVendorForTdsDeduction: payload
      });

    //Rent Bill
    case GET_CURRENT_YEAR_MONTH:
      return Object.assign({}, state, {
        getCurrentYearMonth: payload
      });
    case GET_RENT_DETAIL_FOR_RENT_BILL:
      return Object.assign({}, state, {
        getRentDetailForRentBill: payload
      });

    // consultant fees
    case GET_PROJECT_CONSULTANT:
      return Object.assign({}, state, {
        getProjectConsultant: payload
      });
    case GET_PROJECT_CONSULTANT_FEE:
      return Object.assign({}, state, {
        getProjectConsultantFee: payload
      });
    case GET_PROJECT_CONSULTANT_FEE_EXPORT:
      return Object.assign({}, state, {
        getProjectConsultantFeeExport: payload
      });
    case GET_PROJECT_CONSULTANT_FEE_DETAIL:
      return Object.assign({}, state, {
        getProjectConsultantFeeDetail: payload
      });

    case GET_SURVEY_FOR_PROJECT_CONSULTANT_FEE:
      return Object.assign({}, state, {
        getSurveyForProjectConsultantFee: payload
      });

    case GET_PROJECT_CONSULTANT_FEE_FILTER_PROJECT:
      return Object.assign({}, state, {
        getProjectConsultantFeeFilterProject: payload
      });

    case GET_PROJECT_CONSULTANT_FEE_FILTER_CONSULTANT:
      return Object.assign({}, state, {
        getProjectConsultantFeeFilterConsultant: payload
      });

    // Cheque Template
    case GET_CHEQUE_TEMPLATE:
      return Object.assign({}, state, {
        getChequeTemplate: payload
      });
    case GET_CHEQUE_TEMPLATE_EXPORT:
      return Object.assign({}, state, {
        getChequeTemplateExport: payload
      });
    case GET_CHEQUE_TEMPLATE_DETAIL:
      return Object.assign({}, state, {
        getChequeTemplateDetail: payload
      });
    case GET_CHEQUE_TEMPLATE_FILTER_BANK:
      return Object.assign({}, state, {
        getChequeTemplateFilterBank: payload
      });

    //customer ledger
    case GET_CUSTOMER_LEDGER:
      return Object.assign({}, state, {
        getCustomerLedger: payload
      });
    case GET_CUSTOMER_LEDGER_ITEM_PRINT:
      return Object.assign({}, state, {
        getCustomerLedgerItemPrint: payload
      });
    case GET_CUSTOMER_LEDGER_EXPORT:
      return Object.assign({}, state, {
        getCustomerLedgerExport: payload
      });
    case GET_CUSTOMER_LEDGER_DETAIL:
      return Object.assign({}, state, {
        getCustomerLedgerDetail: payload
      });
    case GET_CUSTOMER_LEDGER_FILTER_PROJECT:
      return Object.assign({}, state, {
        getCustomerLedgerFilterProject: payload
      });
    case GET_CUSTOMER_LEDGER_FILTER_CUSTOMER:
      return Object.assign({}, state, {
        getCustomerLedgerFilterCustomer: payload
      });
    case GET_CUSTOMER_LEDGER_FILTER_COMPANY:
      return Object.assign({}, state, {
        getCustomerLedgerFilterCompany: payload
      });
    case GET_CUSTOMER_LEDGER_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getCustomerLedgerFilterCategory: payload
      });
    case GET_CUSTOMER_LEDGER_ITEM:
      return Object.assign({}, state, {
        getCustomerLedgerItem: payload
      });
    case GET_CUSTOMER_LEDGER_ITEM_EXPORT:
      return Object.assign({}, state, {
        getCustomerLedgerItemExport: payload
      });
    case GET_CUSTOMER_LEDGER_ITEM_FILTER_CUSTOMER:
      return Object.assign({}, state, {
        getCustomerLedgerItemFilterCustomer: payload
      });
    case GET_CUSTOMER_LEDGER_ITEM_FILTER_COMPANY:
      return Object.assign({}, state, {
        getCustomerLedgerItemFilterCompany: payload
      });
    case GET_CUSTOMER_LEDGER_ITEM_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getCustomerLedgerItemFilterCategory: payload
      });
    case GET_CUSTOMER_LEDGER_ITEM_FILTER_PROJECT:
      return Object.assign({}, state, {
        getCustomerLedgerItemFilterProject: payload
      });
    // sales return (Credit Note)
    case GET_SALES_RETURN:
      return Object.assign({}, state, {
        getSalesReturn: payload
      });
    case GET_SALES_RETURN_DETAIL:
      return Object.assign({}, state, {
        getSalesReturnDetail: payload
      });
    case GET_SALES_RETURN_FILTER_COMPANY:
      return Object.assign({}, state, {
        getSalesReturnFilterCompany: payload
      });
    case GET_SALES_RETURN_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesReturnFilterProject: payload
      });

    case GET_SALES_RETURN_EXPORT:
      return Object.assign({}, state, {
        getSalesReturnExport: payload
      });
    //account type
    case GET_ACCOUNT_TYPE:
      return Object.assign({}, state, {
        getAccountType: payload
      });
    default:
      return state;
  }
};

export default Accounts_reducer;
